/**
 * Route for `advertiser-portal`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserPortalPage } from "../features/advertiser-portal/AdvertiserPortalPage";

export const advertiserPortalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-portal",
	component: AdvertiserPortalPage,
});

export default advertiserPortalRoute;
